module.exports = __webpack_public_path__ + "static/media/md-information-circle.8e5cce17.svg";